export default __webpack_public_path__ + "static/media/superdrug_card.476162af.png";